<template>
  <pre :class="`id ${copiedID ? 'copied' : ''}`" @click="copyID(id)" v-if="id"># {{ id }}</pre>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  methods: {
    /**
     * Copy ID to clipboard
     * @param {String} id
     */
    copyID(id) {
      clearTimeout(this.copyTimer);
      window.Clipboard.copy(id);
      this.copiedID = true;
      this.copyTimer = setTimeout(() => {
        this.copiedID = false;
      }, 500);
    },
  },
  data() {
    return {
      copiedID: false,
      copyTimer: null,
    };
  },
  beforeDestroy() {
    clearTimeout(this.copyTimer);
  },
};
</script>

<style lang="scss" scoped>
.id {
  color: #000000;
  font-family: Menlo, Consolas, monospace;
  transition: color .3s;
  pointer-events: all;
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;

  &.copied {
    color: blue;
  }
}
</style>
